import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import * as Icons from 'assets/svg/sprite'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import { usePageTitle } from 'context/pageTitleContext'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import colors from 'styles/colors'

import styles from './_termsandpolicies.module.scss'

export const TermsAndPolicies = () => {
    const { t } = useTranslation()
    const { setTitle } = usePageTitle()

    useEffect(() => {
        setTitle('Support')
    }, [setTitle])

    
    return (
        <WithHeaderSection
            customClass={'termsandpolicies'}
            withoutBorder={false}
            headerSection={
                <StyledHeaderSection>
{/*                     <Icons.supportIcon />
 */}                    <StyledHeaderTitle>
                        {'Terms & Policies'}
                    </StyledHeaderTitle>
                </StyledHeaderSection>
            }
        >
        <div className={styles['terms-content-wrapper']}>
            <ActionCard
                text={'Terms of Service'}
                link='/terms'
                icon={<Icons.IconHowToBook />}
                absFix
                hasArrow
            />
            <ActionCard
                text={t('DMCA')}
                link='/dmca'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <ActionCard
                text={'Privacy Policy'}
                link='/privacypolicy'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <ActionCard
                text={'Complaints Policy'}
                link='/complaintspolicy'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <ActionCard
                text={'Creator Terms'}
                link='/creatorterms'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <ActionCard
                text={'Cookie Policy'}
                link='/cookiepolicy'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <ActionCard
                text={'Fan/Creator Contract'}
                link='/fancreatorcontract'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <ActionCard
                text={'USC 2257'}
                link='/usc'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <ActionCard
                text={'Acceptable Use Policy'}
                link='/acceptableuse'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <ActionCard
                text={'Referral Program Terms'}
                link='/referralterms'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <ActionCard
                text={'CCPA Privacy Policy'}
                link='/ccpapolicy'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <ActionCard
                text={'Content Moderation Policy'}
                link='/contentmoderationpolicy'
                icon={<Icons.IconNote />}
                absFix
                hasArrow
            />
            <StyledBorderLine />
            <ActionCard
                icon={<Icons.IconLightMessage />}
                text='support@allfans.com'
                suptext={t('sendUsAnEmail')}
            />
        </div>
        </WithHeaderSection>
    )
}

const StyledBorderLine = styled.div`
    background-color: ${colors.platinumGray};
    height: 0.1rem;
    margin: 3rem 0;
`

const StyledHeaderSection = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
`

const StyledHeaderTitle = styled.h2`
    font-size: 2.4rem;
    font-weight: 600;
    line-height: 2.9rem;
    letter-spacing: 0.02em;
    margin-bottom: 1rem;
    margin-top: 0.5rem;    
`
